import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { uniqBy } from 'lodash';
import styled from 'styled-components';
import { layout, space } from 'styled-system';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from "../../box/src";
import { FakeLink } from "../../link/src";
import { ScreenReadersContent } from "../../screen-readers-content/src";
import { focusOutline } from "../../theme/src";
import { Tooltip } from "../../tooltip/src";
export const UsersAvatarList = ({ ariaExpanded = false, children, imgSize = 32, maxAvatars = 3, onClickMore, screenReadersListTitle = '', screenReadersMoreButtonText = '', totalUsers = 0, users = [], }) => {
    const uniqueUsers = uniqBy(users, 'id');
    const visibleAvatars = uniqueUsers.slice(0, maxAvatars);
    const nbAvatars = visibleAvatars.length;
    const nbTotalUsers = Math.max(uniqueUsers.length, totalUsers);
    const nbRemainingUsers = nbTotalUsers - nbAvatars;
    const seeMoreLinkLabel = nbRemainingUsers > 0 ? `+${nbRemainingUsers}` : '';
    const usersNames = visibleAvatars.map(({ firstname, lastname, name }, index) => {
        const shouldDisplayComma = index !== nbAvatars - 1 ? ',' : '';
        const userName = name || `${firstname !== null && firstname !== void 0 ? firstname : ''} ${lastname !== null && lastname !== void 0 ? lastname : ''}`;
        return _jsx("div", { children: `${userName}${shouldDisplayComma}` }, name);
    });
    const isClickable = !!onClickMore;
    return (_jsxs(Container, Object.assign({ "$isClickable": isClickable, "data-testid": "ds-users-avatar-list" }, (onClickMore && { onClick: onClickMore }), (onClickMore && { onKeyDown: onEnterOrSpacePress(onClickMore) }), { children: [_jsx(Tooltip, { childrenElement: _jsx(Box, { flexDirection: "column", style: { color: 'inherit' }, children: usersNames }), fixedParent: undefined, hideOnScreenReader: true, id: undefined, initialPosition: undefined, inline: undefined, maxWidth: undefined, onClose: undefined, removeHoverEffect: undefined, shouldRenderTooltip: undefined, style: { display: 'flex' }, type: undefined, children: visibleAvatars.map(({ firstname, id, lastname, name, photo_thumb_url: photoThumbUrl }, index) => {
                    const userName = (name || `${firstname !== null && firstname !== void 0 ? firstname : ''} ${lastname !== null && lastname !== void 0 ? lastname : ''}`).trim();
                    return (_jsxs(WrapperUser, { "$zIndex": nbAvatars - index, "data-testid": "ds-users-avatar-list_user", ml: index === 0 ? 0 : -3, children: [_jsx(Image, { "$size": imgSize, alt: "", "aria-hidden": "true", "data-testid": `ds-users-avatar-list_user_${id}`, src: photoThumbUrl, title: userName }), _jsx(ScreenReadersContent, { children: userName })] }, id));
                }) }), (!!children || nbRemainingUsers > 0) && (_jsx(Box, { ml: 2, children: isClickable ? (_jsx(FakeLink, { "aria-expanded": ariaExpanded, "aria-label": screenReadersListTitle, enableWrap: undefined, onClick: undefined, styledOnlyOnHover: undefined, title: screenReadersMoreButtonText, children: children || seeMoreLinkLabel })) : (_jsx(Box, { fontWeight: "bold", children: children || seeMoreLinkLabel })) }))] })));
};
const Container = styled(Box).attrs({
    alignItems: 'center',
    width: 'fit-content',
}) `
  ${({ $isClickable }) => $isClickable && `cursor: pointer`};
`;
const Image = styled.img.attrs(({ $size }) => ({
    height: $size,
    width: $size,
})) `
  ${layout}
  ${space}
  border-radius: 50%;
  box-shadow: 0px 0px 0px 1px #ffffff;
`;
const WrapperZIndex = (zIndex) => `
  z-index: ${zIndex};
`;
const WrapperUser = styled(Box) `
  flex: 0 0 auto;
  a {
    ${focusOutline}
    border-radius: 50%;
  }
  ${({ $zIndex }) => $zIndex && WrapperZIndex($zIndex)};
`;
//# sourceMappingURL=UsersAvatarList.js.map